// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Bioassays from "../views/Bioassays.vue";

export default [
  {
    path: "/bioassays",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Bioensayos",
        component: Bioassays,
        meta: {
          title: "Bioensayos",
        },
      },
    ],
  },
];
